
export default function toMoney(cents:number, nosign?: boolean) {
  let d = Math.floor(cents / 100)+"";
  let c = (Math.floor(cents % 100)+"").padStart(2, '0');
  return (nosign ? '' : '$') + d + "." + c;
}
